type TitleSecondProps = {
  children: React.ReactNode;
  color?: string;
  highLight?: string;
  width?: string;
};

const TitleSecond = ({
  children,
  color = "color-second",
  highLight = "bg-[var(--textBlue57)]",
  width = "w-full mobile523:w-3/4 md:w-2/3 lg:w-[620px] xl:w-[800px]",
}: TitleSecondProps) => {
  return (
    <div className="flex flex-col items-center  gap-3">
      <div className={`text-xl mobile523:text-2xl sm:text-3xl z-[5] ${color} font-semibold text-center lg:text-center`}>
        {children}
      </div>
      <span className={`block h-[2px] z-[5] ${width} ${highLight}`}></span>
    </div>
  );
};
export default TitleSecond;